module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-fa4d1aea!./packages/dof-status/diablo.css
// module id = 556
// module chunks = 0 1